var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"image",class:'image--' + _vm.size},[_c('img',{attrs:{"src":_vm.getFallbackSrc(_vm.hash),"srcset":_vm.getSrcset(_vm.hash)}})])}
var staticRenderFns = []

export { render, staticRenderFns }